import { memo } from "react";
import type { GoldenSerenityComponentProps } from "./types";
import { GS, formatDate } from "./utils";
import { OrganicDivider } from "./decorations";

export const GoldenSerenityFooter = memo(({ event, config, locale, t }: GoldenSerenityComponentProps) => {
  const initials =
    event.starBride && event.starGroom
      ? `${event.starBride.charAt(0)} & ${event.starGroom.charAt(0)}`
      : event.name
          .split("&")
          .map((n) => n.trim().charAt(0))
          .filter(Boolean)
          .join(" & ");

  const year = event.date ? formatDate(event.date, locale, { year: "numeric" }) : ""; // JUB-154: date may be undecided

  return (
    <footer
      className="relative py-16 text-center"
      style={{ background: `linear-gradient(to bottom, ${GS.creamDeep}, ${GS.creamLight})` }}
    >
      <div className="max-w-6xl mx-auto px-6 space-y-6">
        <OrganicDivider />

        <p
          className="text-3xl font-medium"
          style={{ color: config.palette.text, fontFamily: config.typography.heading }}
        >
          {initials}
        </p>

        <p
          className="text-[10px] uppercase tracking-[0.4em]"
          style={{ color: config.palette.mutedText, fontFamily: config.typography.body }}
        >
          {[year, event.name].filter(Boolean).join(" • ")}
        </p>

        {event.hashtag && (
          <p
            className="text-sm italic"
            style={{ color: GS.gold, fontFamily: config.typography.heading }}
          >
            {event.hashtag.startsWith("#") ? event.hashtag : `#${event.hashtag}`}
          </p>
        )}

        <p
          className="text-xs tracking-wide font-light"
          style={{ color: config.palette.mutedText, fontFamily: config.typography.body }}
        >
          {t("events.form.createdOnJubiel")}
        </p>
      </div>
    </footer>
  );
});

GoldenSerenityFooter.displayName = "GoldenSerenityFooter";
